import React from 'react';
import { Link } from 'react-router-dom';
import { GradientText } from '../components/ui/gradient-text';

export default function Dashboard() {
  return (
    <div className="min-h-[calc(100vh-6rem)] flex flex-col">
      <div className="flex-grow space-y-8">
        <div className="text-center max-w-3xl mx-auto space-y-4">
          <GradientText
            colors={["#0ea5e9", "#6366f1", "#0ea5e9", "#6366f1"]}
            animationSpeed={4}
            className="text-4xl font-bold"
          >
            Manage Your Social Media Presence
          </GradientText>
          <p className="text-gray-600 text-base">
            Schedule posts, manage interactions, and grow your Instagram following with our powerful tools
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
          <Link 
            to="/inbox" 
            className="transform transition-all duration-200 hover:-translate-y-1"
          >
            <div className="h-full bg-white rounded-2xl shadow-sm hover:shadow-md p-8 border border-gray-100">
              <div className="flex flex-col h-full">
                <div className="flex justify-between items-start mb-4">
                  <div className="rounded-full bg-primary-100 w-12 h-12 flex items-center justify-center">
                    <svg className="w-6 h-6 text-primary-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <div className="flex flex-col items-end">
                    <div className="text-sm text-gray-500 line-through">$49/mo</div>
                    <div className="text-sm font-medium text-green-600">Active</div>
                  </div>
                </div>
                <h2 className="text-xl font-semibold mb-2 text-gray-900">Social Media Inbox</h2>
                <p className="text-gray-600 flex-grow">Manage your Instagram DMs and interactions in one place</p>
                <div className="mt-4 inline-flex items-center text-primary-600 font-medium">
                  View Inbox
                  <svg className="ml-2 h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </div>
              </div>
            </div>
          </Link>

          <Link 
            to="/scheduler" 
            className="transform transition-all duration-200 hover:-translate-y-1"
          >
            <div className="h-full bg-white rounded-2xl shadow-sm hover:shadow-md p-8 border border-gray-100">
              <div className="flex flex-col h-full">
                <div className="flex justify-between items-start mb-4">
                  <div className="rounded-full bg-primary-100 w-12 h-12 flex items-center justify-center">
                    <svg className="w-6 h-6 text-primary-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <div className="flex flex-col items-end">
                    <div className="text-sm text-gray-500 line-through">$99/mo</div>
                    <div className="text-sm font-medium text-green-600">Active</div>
                  </div>
                </div>
                <h2 className="text-xl font-semibold mb-2 text-gray-900">Post Scheduler</h2>
                <p className="text-gray-600 flex-grow">Schedule and manage your Instagram posts efficiently</p>
                <div className="mt-4 inline-flex items-center text-primary-600 font-medium">
                  Open Scheduler
                  <svg className="ml-2 h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </div>
              </div>
            </div>
          </Link>

          <Link 
            to="/influencers" 
            className="transform transition-all duration-200 hover:-translate-y-1"
          >
            <div className="h-full bg-white rounded-2xl shadow-sm hover:shadow-md p-8 border border-gray-100">
              <div className="flex flex-col h-full">
                <div className="flex justify-between items-start mb-4">
                  <div className="rounded-full bg-primary-100 w-12 h-12 flex items-center justify-center">
                    <svg className="w-6 h-6 text-primary-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                    </svg>
                  </div>
                  <div className="flex flex-col items-end">
                    <div className="text-sm text-gray-500 line-through">$149/mo</div>
                    <div className="text-sm font-medium text-green-600">Active</div>
                  </div>
                </div>
                <h2 className="text-xl font-semibold mb-2 text-gray-900">Influencer Database</h2>
                <p className="text-gray-600 flex-grow">Discover and connect with Instagram influencers</p>
                <div className="mt-4 inline-flex items-center text-primary-600 font-medium">
                  View Database
                  <svg className="ml-2 h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </div>
              </div>
            </div>
          </Link>
        </div>
      </div>

      <footer className="py-8 mt-16 border-t border-gray-200">
        <div className="text-center text-gray-600 space-y-2">
          <p>Need help? Contact our support team:</p>
          <div className="space-x-4">
            <a href="mailto:office@followsmanager.com" className="text-primary-600 hover:text-primary-700">
              office@followsmanager.com
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}